import useCurrentSubscriptionHelper from 'hooks/billing/useCurrentSubscriptionHelper';
import { useMemo } from 'react';
import { UsageUpsellSkeleton } from '../usage-upsell-skeleton/UsageUpsellSkeleton';
import { DashboardUsageProgressCard } from './components/DashboardUsageProgressCard';
import { DashboardWelcomeCard } from './components/DashboardWelcomeCard';
import { PlanOverviewDetails } from './components/PlanOverviewDetails';

export const DashboardWelcome: React.FC = () => {
    const { currentSubscription, isLoading, isLegacy, planHandle } = useCurrentSubscriptionHelper();

    // Every free plan's handle contains "free", e.g. "free" or "free-xxvi-x"
    const isFreePlan = useMemo(() => !!planHandle?.toLowerCase().includes('free'), [planHandle]);

    if (isLoading) return <UsageUpsellSkeleton />;

    if (!currentSubscription) {
        return <DashboardWelcomeCard />;
    }

    if (isFreePlan) {
        return <DashboardUsageProgressCard />;
    }

    if (!isFreePlan) {
        return <PlanOverviewDetails />;
    }

    return null;
};
